import { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import lodash from 'lodash';

import PageParent from 'components/common/PageParent/PageParent';
import PageHeader from 'components/common/PageHeader/PageHeader';
import FilterBar from 'components/common/FilterBar/FilterBar';
import FilterList from 'components/common/FilterList/FilterList';
import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';

import { loadDataSourceList } from 'pages/dataSource/actions/dataSource';

class DataSourceList extends Component {
    constructor(...args) {
        super(...args);
        this.loadDataSources = lodash.throttle(this.loadDataSources, 75);
    }

    componentDidMount() {
        this.loadDataSources();
    }

    componentDidUpdate(prevProps) {
        const { institutionId, query, filter } = this.props;
        const {
            institutionId: previousInstitutionId,
            query: previousQuery,
            filter: previousFilter
        } = prevProps;
        const institutionIdChanged = !lodash.eq(previousInstitutionId, institutionId);
        const queryChanged = !lodash.eq(previousQuery, query);
        const filterChanged = !lodash.eq(previousFilter, filter);
        if (institutionIdChanged || queryChanged || filterChanged) {
            this.loadDataSources();
        }
    }

    loadDataSources() {
        const { institutionId, query, filter } = this.props;
        this.props.loadDataSourceList(institutionId, { query, type: filter });
    }

    gotoDataSource(dataSource) {
        const path = `/admin/datasources/${dataSource.id}`;
        this.props.push(path);
    }

    dataSourcesAreLoading() {
        const { dataSources, dataSourcesTotalCount } = this.props;
        return lodash.isEmpty(dataSources) && !dataSourcesTotalCount;
    }

    render(){
        const {
            dataSources,
            dataSourcesTotalCount,
            location,
            router,
            query
        } = this.props;
        const currentDataSourceCount = dataSources? Object.keys(dataSources).length : 0;

        const loadingStatus = this.dataSourcesAreLoading();

        return (
            <PageParent data-cy="DataSourceList">
                <PageHeader 
                    headerText={'Data Sources'}
                    subText={'List of pre-defined values that can be linked to a particular Document Attribute'}>
                </PageHeader>
                <FilterBar location={location}
                    router={router}
                    placeholder='Filter by Name' />
                <FilterList listItems={dataSources} accessor={'name'} keysForItem={['id']} gotoListItem={this.gotoDataSource.bind(this)}/>
                <LoadingStatus
                    itemName='Data Sources'
                    loading={loadingStatus && dataSourcesTotalCount !== 0}
                    filterQuery={query}
                    currentItemCount={currentDataSourceCount}
                    totalItemCount={dataSourcesTotalCount}/>
            </PageParent>
        );
    }
}

export default connect((state, props) => {
    const { router, location, location: {query: {q: query, filter}} } = props;
    const institutionId = lodash.get(state, 'me.institution.id');

    return {
        dataSources: state.dataSources,
        dataSourcesTotalCount: state.dataSourcesTotalCount,
        institutionId,
        router,
        location,
        query,
        filter
    };
}, {
    loadDataSourceList,
    push
})(DataSourceList);